/* eslint-disable no-async-promise-executor */
import Ajax from "./ajax";
import OSS from "ali-oss";
import * as _storage from '@/utils/storage.js';

export default {
  fileType: {
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "image/gif": ".gif",
    "audio/mp3": ".mp3",
    "video/mpeg4": ".mp4",
    "application/vnd.ms-powerpoint": ".ppt",
    "application/x-ppt": ".ppt",
    "text/plain": ".txt",
    "application/vnd.ms-excel": ".xls",
    "application/x-xls": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xls",
    "text/xml": ".xml",
    "application/msword": ".doc",
    "video/avi": ".avi",
    "application/x-msdownload": ".exe",
    "text/html": ".html",
    "application/x-jpg": ".jpg",
    "application/x-javascript": ".js",
    "application/x-png": ".png",
    "application/json": "json",
    "application/vnd.adobe.workflow": ".awf"
  },
  getOssSts(roleName) {
    return Ajax.get(
      `/api/live/v1/teacher/ossSts/${roleName}`,
      { roleName: roleName },
      { showLoading: false }
    );
  },
  base64ToFile(base64, name) {
    console.log('base64', base64)
    const mime = 'image/jpeg';
    const fix = this.fileType[mime];
    const bstr = window.atob(base64);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    console.log(u8arr, 'u8arr')
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], name + "-" + Date.now() + fix, {
      type: mime
    });
  },
  uploadOSS(file, type = "*", roleName = "public-read", rename = '', callback) {
    return new Promise(async (resolve, reject) => {
      try {
        const typeArr = type.split(",");
        const some = typeArr.some(t => {
          return file.name.endsWith(t);
        });
        const ftype = this.fileType[file.type];
        if (type === "*") {
        } else if (ftype && type.split(",").indexOf(ftype) > -1) {
        } else if (some) {
        } else if (type === ".store") {
        } else {
          reject(ftype);
          return false;
        }
        const ossSts = await this.getOssSts(roleName);
        const param = {
          accessKeyId:
            ossSts["assumeRoleResponse"]["credentials"]["accessKeyId"],
          accessKeySecret:
            ossSts["assumeRoleResponse"]["credentials"]["accessKeySecret"],
          stsToken:
            ossSts["assumeRoleResponse"]["credentials"]["securityToken"],
          bucket: ossSts["bucket"],
          endpoint: ossSts["endpoint"],
          resource: ossSts["resource"]
        };
        const fixStr = file.name.substring(file.name.lastIndexOf("."));
        const client = new OSS(param);
        console.log(client, 'client')
        const collegeId = _storage.getStorageSync("collegeId");
        const userInfo = _storage.getStorageSync("userInfo");
        const filePath = `${
          param.resource
        }/monitor/${collegeId}/${userInfo.batchId}/${rename}${fixStr}`;
        // let filePath = `${roleName}/answerSheet/${collegeId}/${Date.now()}${fixStr}`;
        let method = "put";
        if (callback) {
          method = "multipartUpload";
        }
        console.log(method, "method");
        client[method](filePath, file, {
          progress: async function(p) {
            // 获取进度条的值
            if (callback) {
              await callback(p);
            }
          }
        })
          .then(res => {
            if (
              res &&
              res.res &&
              res.res.requestUrls &&
              res.res.requestUrls.length > 0 &&
              res.res.requestUrls[0]
            ) {
              let fileUrl = "";
              if (roleName === "public-read") {
                fileUrl = filePath;
                // fileUrl = res.res.requestUrls[0].split("?")[0];
              } else {
                fileUrl = filePath;
              }
              resolve(fileUrl);
              return false;
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  signatureUrl(fullUrl, roleName = "public-read", excelName = "") {
    return new Promise(async (resolve, reject) => {
      let filePath = fullUrl;
      if (!filePath) {
        resolve("");
        return false;
      }
      if (fullUrl.indexOf("://") > -1) {
        filePath = fullUrl.substring(
          fullUrl.indexOf(".com/") + 5,
          fullUrl.indexOf("?") > -1 ? fullUrl.indexOf("?") : fullUrl.length
        );
      }
      const dir = filePath.split("/")[0];
      if (
        ["dev", "prod", "test"].indexOf(dir) > -1 ||
        roleName === "public-read"
      ) {
        const url =
          "//zego-davinci-public.oss-cn-shanghai.aliyuncs.com/" + filePath;
        resolve(url);
        return false;
      }
      const ossSts = await this.getOssSts(roleName);
      const param = {
        accessKeyId: ossSts["assumeRoleResponse"]["credentials"]["accessKeyId"],
        accessKeySecret:
          ossSts["assumeRoleResponse"]["credentials"]["accessKeySecret"],
        stsToken: ossSts["assumeRoleResponse"]["credentials"]["securityToken"],
        bucket: ossSts["bucket"],
        endpoint: ossSts["endpoint"]
      };
      const client = new OSS(param);
      let fileName = filePath;
      if (excelName) {
        const fixStr = filePath.substring(filePath.lastIndexOf("."));
        fileName = `${excelName}${fixStr}`;
      }
      const result = client.signatureUrl(decodeURIComponent(filePath), {
        expires: 3600,
        response: {
          "content-disposition": 'attachment; filename="' + fileName + '"'
        }
      });
      if (result) {
        resolve(result);
      } else {
        reject(param);
      }
    });
  }
};
